import { defineDocStore } from '@/stores/base/baseDocStore'
import { FilterMatchMode } from '@primevue/core/api'
import { type EmailTemplate } from '@/types/EmailTemplate'
import { EmailTemplateModel } from '@/models/EmailTemplateModel'

// Define default filters and sort order
export const defaultFilters = {
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  name: { value: null, matchMode: FilterMatchMode.CONTAINS },
  subject: { value: null, matchMode: FilterMatchMode.CONTAINS },
}

export const defaultSort = {
  field: 'createdAt',
  order: -1,
}

// Create the email template store using the base document store
export const useEmailTemplateStore = defineDocStore<EmailTemplate>({
  entityName: 'emailTemplate',
  collection: 'email_templates',
  model: EmailTemplateModel,
  initialState: {
    filters: defaultFilters,
    sort: defaultSort,
  },
})

// Re-export types and factory for convenience
export type { EmailTemplate } from '@/types/EmailTemplate'
export { createEmailTemplate } from '@/factories/emailTemplateFactory'
